var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancel_Icon",
    "data-name": "Cancel Icon",
    transform: "translate(-217 2899)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16745",
    "data-name": "Ellipse 16745",
    cx: 86,
    cy: 86,
    r: 86,
    transform: "translate(217 -2899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    "data-name": "Icon metro-cross",
    d: "M83.2,67.3h0L58.515,42.614,83.2,17.928h0a2.549,2.549,0,0,0,0-3.6L71.539,2.671a2.55,2.55,0,0,0-3.6,0h0L43.257,27.357,18.571,2.671h0a2.549,2.549,0,0,0-3.6,0L3.314,14.332a2.549,2.549,0,0,0,0,3.6h0L28,42.614,3.314,67.3h0a2.548,2.548,0,0,0,0,3.6L14.975,82.558a2.549,2.549,0,0,0,3.6,0h0L43.257,57.872,67.943,82.558h0a2.548,2.548,0,0,0,3.6,0L83.2,70.9a2.548,2.548,0,0,0,0-3.6Z",
    transform: "translate(257.864 -2855.364)",
    fill: "#356f92"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.ecd1772c35ad74d2fefdbcd00dbad892.svg";
export { ForwardRef as ReactComponent };